module.exports = __webpack_public_path__ + "static/media/integral-logo-charcoal.0826531d.svg";